export const FAVORITES_TYPES = {
  LIBRARY: "libraryItems",
  VIDEO: "videoItems",
  COURSES: "courses",
};
